module.exports = __webpack_public_path__ + "static/img/sindex_banner2.53e6a6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/sindex_banner2.jpg
// module id = k1Zw
// module chunks = 1